import { getService } from '@wix/ambassador-bookings-services-v2-service/http';
import { getEvent } from '@wix/ambassador-events-v1-event/http';
import { queryAvailableTickets } from '@wix/ambassador-events-v1-order/http';
import { listPublicPlans } from '@wix/ambassador-pricing-plans-v2-plan/http';
import { getItem } from '@wix/ambassador-restaurants-menus-v1-item/http';
import { getMenu } from '@wix/ambassador-restaurants-menus-v1-menu/http';
import { getSection } from '@wix/ambassador-restaurants-menus-v1-section/http';
import { getCollection, getProduct } from '@wix/ambassador-stores-catalog-v1-product/http';
import { ScopeGroup, ScopeNamespace } from '../constants';
export async function getCouponEntityName(_ref) {
  let {
    couponScope,
    httpClient
  } = _ref;
  const {
    namespace,
    group
  } = couponScope;
  if (!namespace || !(group != null && group.name) || !(group != null && group.entityId)) {
    return null;
  }
  const {
    entityId
  } = group;
  if (namespace === ScopeNamespace.Stores) {
    // Stores product
    if (group.name === ScopeGroup.Product) {
      var _response$data$produc;
      const response = await httpClient.request(getProduct({
        id: entityId
      }));
      return ((_response$data$produc = response.data.product) == null ? void 0 : _response$data$produc.name) ?? null;
    }
    // Stores collection
    else if (group.name === ScopeGroup.Collection) {
      var _response$data$collec;
      const response = await httpClient.request(getCollection({
        id: entityId
      }));
      return ((_response$data$collec = response.data.collection) == null ? void 0 : _response$data$collec.name) ?? null;
    }
  } else if (namespace === ScopeNamespace.Events) {
    // Event
    if (group.name === ScopeGroup.Event) {
      var _response$data$event;
      const response = await httpClient.request(getEvent({
        id: entityId
      }));
      return ((_response$data$event = response.data.event) == null ? void 0 : _response$data$event.title) ?? null;
    }
    // Event ticket
    else if (group.name === ScopeGroup.Ticket) {
      var _response$data$defini;
      const response = await httpClient.request(queryAvailableTickets({
        limit: 1,
        filter: {
          id: entityId
        }
      }));
      return ((_response$data$defini = response.data.definitions) == null || (_response$data$defini = _response$data$defini[0]) == null ? void 0 : _response$data$defini.name) ?? null;
    }
  }
  // Pricing plan
  else if (namespace === ScopeNamespace.PricingPlans && group.name === ScopeGroup.Plan) {
    var _response$data$plans;
    const response = await httpClient.request(listPublicPlans({
      planIds: [entityId],
      limit: 1
    }));
    return ((_response$data$plans = response.data.plans) == null || (_response$data$plans = _response$data$plans[0]) == null ? void 0 : _response$data$plans.name) ?? null;
  }
  // Bookings service
  else if (namespace === ScopeNamespace.Bookings && group.name === ScopeGroup.Service) {
    var _response$data$servic;
    const response = await httpClient.request(getService({
      serviceId: entityId
    }));
    return ((_response$data$servic = response.data.service) == null ? void 0 : _response$data$servic.name) ?? null;
  } else if (namespace === ScopeNamespace.Restaurants) {
    // Restaurants menu
    if (group.name === ScopeGroup.Menu) {
      var _response$data$menu;
      const response = await httpClient.request(getMenu({
        menuId: entityId
      }));
      return ((_response$data$menu = response.data.menu) == null ? void 0 : _response$data$menu.name) ?? null;
    }
    // Restaurants menu section
    else if (group.name === ScopeGroup.MenuSection) {
      var _response$data$sectio;
      const response = await httpClient.request(getSection({
        sectionId: entityId
      }));
      return ((_response$data$sectio = response.data.section) == null ? void 0 : _response$data$sectio.name) ?? null;
    }
    // Restaurants menu item
    else if (group.name === ScopeGroup.MenuItem) {
      var _response$data$item;
      const response = await httpClient.request(getItem({
        itemId: entityId
      }));
      return ((_response$data$item = response.data.item) == null ? void 0 : _response$data$item.name) ?? null;
    }
  }
  return null;
}
//# sourceMappingURL=getCouponEntityName.js.map